// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".current-plan-badge[data-v-7af45205] {\n  border: 2px solid;\n  padding: 5px;\n}\n.collapsed .when-open[data-v-7af45205],\n.not-collapsed .when-closed[data-v-7af45205] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
